export interface IUnitRequestType {
  id?: number;
  name?: string;
  abbreviation?: string;
  isDefault?: boolean;
  system?: string;
  status?: string;
  restaurantId?: number;
  createdBy?: number;
  updatedBy?: number;
  createdAt?: Date;
  updatedAt?: Date;
}

export interface IConversion {
  id: number;
  fromUnitId?: number;
  conversionFactor?: number;
  toUnit?: {
    id: number;
    name: string;
    abbreviation: string;
  };
}
export interface IAllUnitsResponseType {
  response: {
    success: boolean;
    data: { units: [IUnitDataResponse] } | [];
    message: string;
    error: string | null;
  };
  statusCode: number;
}

export interface IUnitByIdResponseType {
  response: {
    success: boolean;
    data: { unit: IUnitDataResponse | null };
    message: string;
  };
  statusCode: number;
}

export interface ICreatedUnitResponseType {
  success: boolean;
  data: IUnitRequestType;
  message: string;
}

export interface IUnitDataResponse {
  id: number;
  name?: string;
  abbreviation?: string;
  isDefault?: boolean;
  system?: string;
  status?: string;
  restaurantId?: number;
  createdBy?: number;
  updatedBy?: number;
  createdAt?: Date;
  updatedAt?: Date;
}

export interface ICheckUnitConversionResponse {
  exist: boolean;
  conversionFactor?: number;
}

export enum UnitTypes {
  ITEMIZED = 'Itemized',
  NON_ITEMIZED = 'NonItemized',
}
